export default __webpack_public_path__ + "static/media/banner-rapid.c32a9288.jpg";